// extracted by mini-css-extract-plugin
export default {"no_data_container":"NoDataAvailable_no_data_container__2yS2J"};